import React from 'react';
import { observer } from 'mobx-react';
const Icons = observer(() => {
  const icons = [{
    name: 'arrow-down',
    icon: 'arrow-down.svg'
  }];
  const containers = ['home-configurator'];
  return /*#__PURE__*/React.createElement("style", null, icons.reduce((res, i) => {
    const containerClasses = containers.map(c => `.${c} .icon.${i.name}`);
    const url = `url('${"https://objectstorage.eu-frankfurt-1.oraclecloud.com/n/fronf8xprl08/b/tecma-assets-coll/o"}/FloorPlanning/img/icon/${i.icon}');`;
    let css;
    if (!i.noMask) css = `
                ${containerClasses.join(',')} {
                  background-color: ${i.color ? i.color : 'black'};
                  -webkit-mask-image: ${url}
                  mask: ${url}
                  -webkit-mask-repeat: no-repeat;
                  -webkit-mask-position: center;
                  ${i.customCSS ? i.customCSS : ''}
                }
              `;else css = `
                ${containerClasses.join(',')} {
                  background-image: url('${"https://objectstorage.eu-frankfurt-1.oraclecloud.com/n/fronf8xprl08/b/tecma-assets-coll/o"}/HomeConfigurator/img/icon/${i.icon}');
                  ${i.customCSS ? i.customCSS : ''}
                }
              `;
    return res.concat(css);
  }, []));
});
export default Icons;